import { forwardRef, ReactElement, useRef, useState } from 'react'
import { Button, Popover, Whisper } from 'rsuite'
import { signOut } from 'next-auth/react'
import { WhisperInstance } from 'rsuite/Whisper'
import CustomText from '../base/CustomText'

type Props = {
  children: ReactElement
}

type PopoverProps = {
  onClose: () => void
}

const SignOutPopover = forwardRef<HTMLDivElement, PopoverProps>(function SignOutPopover({ onClose, ...props }, ref) {
  return (
    <Popover ref={ref} {...props}>
      <div className="space-y-2">
        <CustomText size="caption" weight={600} className="text-center">
          ¿De verdad quieres cerrar sesión?
        </CustomText>
        <div className="flex justify-between space-x-1" style={{ width: 240 }}>
          <Button onClick={() => signOut()} color="red" appearance="primary" className="flex-1">
            Cerrar sesión
          </Button>
          <Button onClick={onClose} className="flex-1">
            Cancelar
          </Button>
        </div>
      </div>
    </Popover>
  )
})

const SignOutWhisper = ({ children }: Props): JSX.Element => {
  const whisperRef = useRef<WhisperInstance>(null)
  const [optionsContainer, setOptionsContainer] = useState<HTMLDivElement | null>(null)
  return (
    <div className="relative" ref={(ref) => setOptionsContainer(ref)}>
      {optionsContainer ? (
        <Whisper
          ref={whisperRef}
          container={() => optionsContainer}
          trigger="click"
          placement="top"
          speaker={<SignOutPopover onClose={() => whisperRef.current?.close()} />}
          enterable
        >
          {children}
        </Whisper>
      ) : null}
    </div>
  )
}

export default SignOutWhisper
